// OpenAI web search pricing verified August 2026:
// https://developers.openai.com/api/docs/pricing#tools
export const WEB_SEARCH_PRICE_PER_1000_CALLS_USD = 10;
export const WEB_SEARCH_PRICE_PER_CALL_USD = WEB_SEARCH_PRICE_PER_1000_CALLS_USD / 1000;

export function normalizeSearchCallCount(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : 0;
}

export function getSearchCallCount(promptContent) {
  const webSearchDetails =
    promptContent?.webSearchDetails ?? promptContent?.WebSearchDetails;
  const searchCallCount =
    webSearchDetails?.searchCallCount ?? webSearchDetails?.SearchCallCount;

  return normalizeSearchCallCount(searchCallCount);
}

export function calculateWebSearchCost(searchCallCount) {
  return normalizeSearchCallCount(searchCallCount) * WEB_SEARCH_PRICE_PER_CALL_USD;
}
